module.exports = __webpack_public_path__ + "static/img/051 2.e571d643.jpg";